import api from '../../components/api'
import { CuratedTemplate, CuratedTemplatesPage, CuratedTemplateUpsertRequest } from './curatedTemplate'

export const curatedTemplatesEndpoint = '/web/admin/curated-templates'

export const getCuratedTemplatesPage = async (page: number, pageSize: number): Promise<CuratedTemplatesPage> => {
  return (await api.get(curatedTemplatesEndpoint, { params: { page, pageSize } })).data
}

export const getCuratedTemplate = async (curatedTemplateId: string): Promise<CuratedTemplate> => {
  return (await api.get(`${curatedTemplatesEndpoint}/${curatedTemplateId}`)).data
}

export const upsertCuratedTemplate = async (template: CuratedTemplateUpsertRequest): Promise<void> => {
  await api.post(curatedTemplatesEndpoint, template)
}
